import backstageApi from 'api/backstage';
import resourceLibraryApi from 'api/resourceLibrary';
import teacherApi from 'api/teacher';
import electronicCommerceApi from 'api/electronicCommerce';
import courseApi from 'api/course';
import oneClubSNSApi from 'api/oneClubSNS';
import oneClubUsers from 'api/oneClubUsers';
import bitrixApi from 'api/bitrix';
import bitrixHook from 'api/bitrixHook';
import liveClassApi from 'api/liveClass';
import teachersBackendApi from 'api/teacherManagement';
import teachersApi from 'api/teachers';
import oneClassApiGateway from 'api/oneClassApiGateway';
import salaryApi from 'api/salary';
import bonusApi from 'api/bonus';
import tagApi from 'api/tag';
import oneboardApi from 'api/oneboard';
import leaveApi from 'api/leave';
import oneExamApi from 'api/oneExam';
import googleSheet from 'api/googleSheet';
import performanceApi from 'api/perfomance';
import teacherRecruitment from 'api/teacherRecruitment';
import schoolApi from 'api/school';
import sendbirdApi from 'api/sendbird';
import funLearningApi from 'api/funLearning';
import oneAnswerApi from 'api/oneAnswer/oneAnswer';
import mmsApi from 'api/mms';
import productApi from 'api/product';
import oneClassNow from 'api/oneClassNow';
import notificationCenter from 'api/notificationCenter';
import streamCourseVideoApi from 'api/streamCourseVideo';
import linkPlusApi from 'api/link-plus';
import memberCenterApi from 'api/member-center';
import instance from './instance';
import proxyInstance from './proxy-instance';

const ONECLASS_API_GATEWAY_DOMAIN = import.meta.env
  .VITE_ONECLASS_API_GATEWAY_DOMAIN;

export const URL = {
  BACKSTAGE: `${ONECLASS_API_GATEWAY_DOMAIN}/staff`,
  TEACHER_RECRUITMENT: `${ONECLASS_API_GATEWAY_DOMAIN}/teacher-recruitment`,
  ELECTRONIC_COMMERCE: `${ONECLASS_API_GATEWAY_DOMAIN}/product`,
  TEACHERS_MANAGEMENT: `${ONECLASS_API_GATEWAY_DOMAIN}/teacher`,
  ONECLASS_API_GATEWAY: ONECLASS_API_GATEWAY_DOMAIN,
  MMS: `${ONECLASS_API_GATEWAY_DOMAIN}/mms`,
  SENDBIRD_API: `${ONECLASS_API_GATEWAY_DOMAIN}/im`,
  FUN_LEARNING: `${ONECLASS_API_GATEWAY_DOMAIN}/funlearning`,
  ONE_ANSWER: `${ONECLASS_API_GATEWAY_DOMAIN}/one-answer`,
  NOTIFICATION_CENTER: `${ONECLASS_API_GATEWAY_DOMAIN}/notification-center`,
  MEMBER_CENTER: `${ONECLASS_API_GATEWAY_DOMAIN}/member-center`,
  ONECLUB: import.meta.env.VITE_ONECLUB_API_DOMAIN,
  TEACHER: import.meta.env.VITE_TEACHER_API_DOMAIN,
  RESOURCE_LIBRARY: import.meta.env.VITE_RESOURCE_LIBRARY_API_DOMAIN,
  SCHOOL_API: import.meta.env.VITE_SCHOOL_API_DOMAIN,
  STREAM_COURSE_VIDEO: import.meta.env.VITE_STREAM_COURSE_VIDEO_API_DOMAIN,
  ONEBOARD: import.meta.env.VITE_ONEBOARD_API_URL,
  ONEEXAM_API: import.meta.env.VITE_ONEEXAM_API_DOMAIN,
  GOOGLE_SHEET: import.meta.env.VITE_GOOGLE_SHEET_DOMAIN,
  EDU_SUBJECT_VN: import.meta.env.VITE_EDU_SUBJECT_VN,
  COURSE: import.meta.env.VITE_COURSE_API_DOMAIN,
  ONECLUB_SNS: import.meta.env.VITE_ONECLUB_SNS_DOMAIN,
  ONECLUB_USERS: import.meta.env.VITE_ONECLUB_USERS_DOMAIN,
  BITRIX: import.meta.env.VITE_BITRIX_PROD_API_DOMAIN,
  BITRIX_HOOK: import.meta.env.VITE_BITRIX_HOOK_DOMAIN,
  LIVE_CLASS: import.meta.env.VITE_LIVE_CLASS_API_DOMAIN,
  ORDER: import.meta.env.VITE_ORDER_RESULT_DOMAIN,
};

export default {
  rootApiteacherRecruitment: teacherRecruitment(
    instance,
    URL.ONECLASS_API_GATEWAY,
  ),
  backstage: backstageApi(instance, URL.BACKSTAGE),
  resourceLibrary: resourceLibraryApi(instance, `${URL.RESOURCE_LIBRARY}/api`),
  teacher: teacherApi(instance, `${URL.TEACHER}/teachers`),
  teacherRecruitment: teacherRecruitment(instance, URL.TEACHER_RECRUITMENT),
  electronicCommerce: electronicCommerceApi(instance, URL.ELECTRONIC_COMMERCE),
  course: courseApi(instance, `${URL.COURSE}/api`),
  oneClubSNS: oneClubSNSApi(instance, `${URL.ONECLUB_SNS}`),
  oneClubUsers: oneClubUsers(instance, `${URL.ONECLUB_USERS}`),
  bitrix: bitrixApi(instance, `${URL.BITRIX}`),
  bitrixHook: bitrixHook(instance, `${URL.BITRIX_HOOK}`),
  liveClass: liveClassApi(instance, `${URL.LIVE_CLASS}`),
  teachersManagement: teachersBackendApi(
    instance,
    `${URL.TEACHERS_MANAGEMENT}/api`,
  ),
  teachers: teachersApi(instance, `${URL.TEACHERS_MANAGEMENT}/api`),
  oneClassApiGateway: oneClassApiGateway(instance, URL.MMS),
  salary: salaryApi(instance, URL.MMS),
  bonus: bonusApi(instance, `${URL.MMS}/backend/bonus`),
  tag: tagApi(instance, URL.MMS),
  oneboard: oneboardApi(instance, URL.ONEBOARD),
  leave: leaveApi(instance, URL.MMS),
  oneExam: oneExamApi(instance, `${URL.ONEEXAM_API}`),
  googleSheet: googleSheet(instance, `${URL.GOOGLE_SHEET}`),
  performance: performanceApi(instance, URL.ELECTRONIC_COMMERCE),
  eduSubjectVN: oneClassApiGateway(instance, `${URL.EDU_SUBJECT_VN}`),
  school: schoolApi(instance, `${URL.SCHOOL_API}`),
  sendbird: sendbirdApi(instance, `${URL.SENDBIRD_API}`),
  funLearning: funLearningApi(instance, URL.FUN_LEARNING),
  oneAnswer: oneAnswerApi(instance, URL.ONE_ANSWER),
  mms: mmsApi(instance, URL.MMS),
  product: productApi(instance, URL.ELECTRONIC_COMMERCE),
  oneClassNow: oneClassNow(instance, URL.MMS),
  notificationCenter: notificationCenter(instance, URL.NOTIFICATION_CENTER),
  streamCourseVideo: streamCourseVideoApi(instance, URL.STREAM_COURSE_VIDEO),
  linkPlus: linkPlusApi(
    proxyInstance,
    `${URL.ONECLASS_API_GATEWAY}/mms/proxy/link-plus`,
  ),
  memberCenter: memberCenterApi(instance, URL.MEMBER_CENTER),
};
